import React from 'react'
import i18n from 'translations/i18n'
import { useDispatch, useSelector } from 'react-redux'
import { Flex, Button, Spacer } from '@jisr-hr/design-system'
import { Button as DSButton } from '@jisr-hr/ds'
import DSIcon from 'components/DSIcon'
import { useFormState } from 'react-final-form'
import { taskDetailLoad, updateTask } from 'redux/requests/newRequestsApproval/actionCreators'
import FileInput from 'components/global/form/FileInput'
import { DatePickerDSField } from 'components/final-form'
import { ReactComponent as CheckIcon } from '../icons/check.svg'
import { ReactComponent as AttachFileIcon } from '../components/Reason/icons/attach-file.svg'
import { useRequest } from '../RequestProvider'

const TaskActions = ({ handlePrint }) => {
  const dispatch = useDispatch()
  const {
    vars: { request },
    drawerToggle,
    actionCallback,
    showPaymentDate,
    setShowPaymentDate,
  } = useRequest()
  const { status } = request
  const { fetching_submit } = useSelector((state) => state.approvals)
  const { values } = useFormState()
  const showPayment =
    [
      'loan_payment_task',
      'advance_vacation_salary_payment_task',
      'final_settlement_payment_task',
      'expense_claim_payment_task',
      'business_trip_payment_task',
    ].includes(request.category) && request.can_mark_as_completed

  const reloadAfterAction = (action) => {
    return dispatch(action).then(() =>
      dispatch(taskDetailLoad(request.id)).then(() => {
        drawerToggle()
        if (actionCallback) {
          actionCallback()
        }
      }),
    )
  }

  const handlPaymentDate = () => {
    reloadAfterAction(
      updateTask(request.id, { task: { status: 'Completed', paid_at: values?.paid_at } }),
    )
  }

  const handlemarkAsCompleted = () => {
    if (showPayment) {
      setShowPaymentDate(true)
    } else {
      reloadAfterAction(updateTask(request.id, { task: { status: 'Completed' } }))
    }
  }

  const onAttachTaskFile = (file) => {
    reloadAfterAction(updateTask(request.id, { task: { ...file } }))
  }

  return (
    <>
      <Flex justifyBetween>
        {status === 'Pending' && !showPaymentDate && request.can_mark_as_completed && (
          <Flex style={{ gap: '8px' }}>
            <Button
              label={i18n.t('mark_as_completed')}
              size="small"
              variant="primary"
              startIcon={<CheckIcon />}
              onClick={handlemarkAsCompleted}
              disabled={fetching_submit}
              data-testid="pending-request-details-approve"
            />
            <label>
              <Button
                label={i18n.t('attach')}
                size="small"
                variant="secondary"
                startIcon={<AttachFileIcon />}
                onClick={() => document.getElementById('attachTaskFile').click()}
                data-testid="pending-request-details-reject"
                disabled={fetching_submit}
              />
              <FileInput
                id="attachTaskFile"
                onDone={onAttachTaskFile}
                className="hidden"
              />
            </label>
          </Flex>
        )}
        {!showPaymentDate && (
          <DSButton
            label={i18n.t('print')}
            size="sm"
            variant="secondary"
            iconLeading={<DSIcon name="printer" />}
            onClick={handlePrint}
          />
        )}
      </Flex>

      {showPaymentDate && (
        <Flex
          flexCol
          style={{ width: '100%' }}
        >
          <DatePickerDSField
            name="paid_at"
            placeholder={i18n.t('select_date')}
            label={i18n.t('payment_date')}
            style={{ zIndex: 9999 }}
          />
          <Spacer height="30px" />
          <Flex style={{ gap: '8px' }}>
            <Button
              label={i18n.t('confirm')}
              size="small"
              variant="primary"
              onClick={handlPaymentDate}
              disabled={!values?.paid_at || fetching_submit}
              data-testid="reject-comment-btn"
            />
            <Button
              label={i18n.t('cancel')}
              size="small"
              variant="secondary"
              onClick={() => setShowPaymentDate(false)}
              data-testid="cancel-comment-btn"
            />
          </Flex>
        </Flex>
      )}
    </>
  )
}

export default TaskActions
